export default "__VITE_ASSET__B63O0CLL__"